import { render, staticRenderFns } from "./RichTextComponent.vue?vue&type=template&id=10103f04&scoped=true"
import script from "./RichTextComponent.vue?vue&type=script&lang=js"
export * from "./RichTextComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10103f04",
  null
  
)

export default component.exports